import { render, staticRenderFns } from "./InventoryReport.vue?vue&type=template&id=63ef21e9&scoped=true&"
import script from "./InventoryReport.vue?vue&type=script&lang=js&"
export * from "./InventoryReport.vue?vue&type=script&lang=js&"
import style0 from "./InventoryReport.vue?vue&type=style&index=0&id=63ef21e9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ef21e9",
  null
  
)

export default component.exports